import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import { getCurrentUser } from 'helpers/Utils';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    MILESTONES_FETCH_ITEM,
    MILESTONES_ADD_ITEM,
    MILESTONES_DELETE_ITEM
} from './actions_def';
import {
    getMilestoneItemSuccess,
    getMilestoneItemError,
    addMilestonesItemSuccess,
    addMilestonesItemError,
    deleteMilestoneItemSuccess,
    deleteMilestoneItemError


} from './actions';


const apiUrl = servicePath;


const getMilestoneItemRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    // // console.log(payload);;
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/milestones/' + payload.milestoneId, { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => (
                    {
                        id: item.rfc_id,
                        title: item.rfc_title,
                        date: moment(item.date_created).format("Do MMM YYYY"),
                        change_date: moment(item.date_modified).format("Do MMM YYYY (hh:mm)"),
                        end_date: moment(item.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
                        status: item.rfc_status,
                        statusColor: 'primary'
                    }
                )
                )
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getMilestoneItem({ payload }) {
    // // console.log(payload);;
    try {
        const response = yield call(getMilestoneItemRequest, payload);
        yield put(getMilestoneItemSuccess(response));
    } catch (error) {
        yield put(getMilestoneItemError(error));
    }
}


const addMilestonesItemRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    console.log(item);
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        var _user = getCurrentUser(); // JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (item.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        let _sendingPayload = {
            Name: item.name,
            ProjectId: item.projectId,
            Notes: item.description ? item.description : ' ',
            DueDate: item.due_date ? item.due_date : new Date(),
            ReleaseDate: item.due_date ? item.due_date : new Date(),
        };

        // console.log(_sendingPayload, getAccessToken());
        instance.post('/milestones/',
            _sendingPayload,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.status !== 200 && response.data.status !== 201) {
                        fail(response.data);
                    }
                    else {
                        success(response.data);
                    }
                }
            }).catch((error) => {
                console.log(error)
            });;
    })
        .then((response) => response)
        .catch((error) => error);
};

function* addMilestonesItem({ payload }) {
    // // console.log(payload);;
    try {
        const response = yield call(addMilestonesItemRequest, payload);
        console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(addMilestonesItemSuccess(response));
        }
        else {
            yield put(addMilestonesItemError(response));
        }
    } catch (error) {
        yield put(addMilestonesItemError(error));
    }
}


const deleteMilestoneRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {
        console.log(item)
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        instance.delete('/milestones/' + item.milestoneId,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.status === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.status === "success" || response.data.status === "ok") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.status);
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteMilestoneItem({ payload }) {
    // console.log(payload);
    try {
        const response = yield call(deleteMilestoneRequest, payload);
        console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(deleteMilestoneItemSuccess(response));
        }
        else {
            yield put(deleteMilestoneItemError(response));
        }
    } catch (error) {
        yield put(addMilestonesItemError(error));
    }
}


export function* watchFetchItem() {
    yield takeEvery(MILESTONES_FETCH_ITEM, getMilestoneItem);
}

export function* watchAddItem() {
    yield takeEvery(MILESTONES_ADD_ITEM, addMilestonesItem);
}
export function* watchDeleteItem() {
    yield takeEvery(MILESTONES_DELETE_ITEM, deleteMilestoneItem);
}


export default function* rootSaga() {
    yield all([
        fork(watchAddItem),
        fork(watchFetchItem),
        fork(watchDeleteItem),
    ]);
}
